export default __webpack_public_path__ + "static/media/grass-background.bf7d6346.jpg";